module.exports = __webpack_public_path__ + "img/edge_activites_visite_guidee.c04e37d6.svg";